import React from 'react'

type ReviewProgressBarProps = {
  currentStep: number
  totalSteps: number
}

export const ReviewProgressBar: React.FC<ReviewProgressBarProps> = ({ currentStep, totalSteps }) => {
  const percent = totalSteps > 0 ? Math.round((currentStep / totalSteps) * 100) : 0

  return (
    <div className="mb-6">
      <div className="mb-2 flex items-center justify-between text-sm font-medium text-graphite-grey">
        <span>
          Step {currentStep} of {totalSteps}
        </span>
        <span>{percent}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-royal-indigo transition-all duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
